import React, { Component } from 'react';
import FaSearchPlus from 'react-icons/lib/fa/search-plus';
import FaSearchMinus from 'react-icons/lib/fa/search-minus';
import PropTypes from 'prop-types';
import Styles from './Minimap.styles';
import './minimap.css';

class Minimap extends Component {
  constructor(props) {
    super(props);

    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onClick = this.onClick.bind(this);

    this.state = {
      initialImageMapWidth: null,
      initialImageMapHeight: null,
    };

    this.grabX = 0;
    this.grabY = 0;
  }

  onClick(event) {
    const minimapWidth = Math.round(this.props.editorWidth * 0.15);
    const minimapHeight = Math.round(this.props.editorHeight * 0.15);
    const box = this.container.getBoundingClientRect();
    const imagePositionX = Math.min(
      1,
      Math.max(
        0,
        (event.clientX - box.left) / minimapWidth - 0.5 * this.props.minimapWidthPercentage,
      ),
    );
    const imagePositionY = Math.min(
      1,
      Math.max(
        0,
        (event.clientY - box.top) / minimapHeight - 0.5 * this.props.minimapHeightPercentage,
      ),
    );
    this.props.onClick(imagePositionX, imagePositionY);
  }

  onMouseDown(event) {
    if (event.nativeEvent.target === this.pointer) {
      event.nativeEvent.preventDefault();
      this.container.addEventListener('mousemove', this.onMouseMove);
      this.container.addEventListener('mouseup', this.onMouseUp);
    }
  }

  onMouseMove(event) {
    if (event.target === this.pointer) {
      event.preventDefault();
      const minimapWidth = Math.round(this.props.editorWidth * 0.15);
      const minimapHeight = Math.round(this.props.editorHeight * 0.15);
      const box = this.container.getBoundingClientRect();
      const imagePositionX = Math.min(
        1,
        Math.max(
          0,
          (event.clientX - box.left) / minimapWidth - 0.5 * this.props.minimapWidthPercentage,
        ),
      );
      const imagePositionY = Math.min(
        1,
        Math.max(
          0,
          (event.clientY - box.top) / minimapHeight - 0.5 * this.props.minimapHeightPercentage,
        ),
      );
      this.props.onMouseMove(imagePositionX, imagePositionY);
    } else {
      this.container.removeEventListener('mousemove', this.onMouseMove);
      this.container.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  onMouseUp(event) {
    event.preventDefault();
    this.container.removeEventListener('mousemove', this.onMouseMove);
    this.container.removeEventListener('mouseup', this.onMouseUp);
  }

  zoomIn(e) {
    e.stopPropagation();
    const { zoom, maxZoom } = this.props;
    if (zoom + 1 < maxZoom) {
      this.props.onZoomIn();
    }
  }

  zoomOut(e) {
    e.stopPropagation();
    const { zoom } = this.props;
    if (zoom - 1 >= 0) {
      this.props.onZoomOut();
    }
  }

  render() {
    const minimapWidth = Math.round(this.props.editorWidth * 0.15);
    const minimapHeight = Math.round(this.props.editorHeight * 0.15);

    const initialImageMapWidth = this.props.imageNaturalWidth * this.props.initialScale * 0.15;
    const initialImageMapHeight = this.props.imageNaturalHeight * this.props.initialScale * 0.15;
    return (
      <div
        role="presentation"
        style={Styles.minimapContainer(minimapWidth, minimapHeight)}
        ref={(container) => {
          this.container = container;
        }}
        onClick={this.onClick}
      >
        <div
          style={{
            width: `${minimapWidth}px`,
            height: `${minimapHeight}px`,
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.1)',
            outline: '1px solid rgba(0,0,0,0.4)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div style={Styles.imageShadow(initialImageMapWidth, initialImageMapHeight)} />
          <div
            role="presentation"
            ref={(pointer) => {
              this.pointer = pointer;
            }}
            onMouseDown={this.onMouseDown}
            style={Styles.pointer(
              this.props.minimapWidthPercentage,
              this.props.minimapHeightPercentage,
              this.props.positionXPercentage,
              this.props.positionYPercentage,
            )}
            className="minimap-pointer"
          />
        </div>
        <div style={Styles.zoomWrapper}>
          <FaSearchPlus size={20} style={Styles.zoomButton} onClick={this.zoomIn} />
          <FaSearchMinus size={20} style={Styles.zoomButton} onClick={this.zoomOut} />
        </div>
      </div>
    );
  }
}

Minimap.defaultProps = {
  positionXPercentage: 0,
  positionYPercentage: 0,
  minimapWidthPercentage: 0,
  minimapHeightPercentage: 0,
  imageNaturalWidth: 0,
  imageNaturalHeight: 0,
  editorWidth: 0,
  editorHeight: 0,
  initialScale: 0,
  zoom: 0,
  maxZoom: 0,
};

Minimap.propTypes = {
  positionXPercentage: PropTypes.number,
  positionYPercentage: PropTypes.number,
  minimapWidthPercentage: PropTypes.number,
  minimapHeightPercentage: PropTypes.number,
  imageNaturalWidth: PropTypes.number,
  imageNaturalHeight: PropTypes.number,
  editorWidth: PropTypes.number,
  editorHeight: PropTypes.number,
  initialScale: PropTypes.number,
  onZoomOut: PropTypes.func.isRequired,
  onZoomIn: PropTypes.func.isRequired,
  onMouseMove: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  zoom: PropTypes.number,
  maxZoom: PropTypes.number,
};

export default Minimap;



// WEBPACK FOOTER //
// ./src/components/Map/Minimap/Minimap.js